var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 2.66927H10.5003C10.8539 2.66927 11.1931 2.80975 11.4431 3.0598C11.6932 3.30984 11.8337 3.64898 11.8337 4.0026V13.3359C11.8337 13.6896 11.6932 14.0287 11.4431 14.2787C11.1931 14.5288 10.8539 14.6693 10.5003 14.6693H2.50033C2.1467 14.6693 1.80756 14.5288 1.55752 14.2787C1.30747 14.0287 1.16699 13.6896 1.16699 13.3359V4.0026C1.16699 3.64898 1.30747 3.30984 1.55752 3.0598C1.80756 2.80975 2.1467 2.66927 2.50033 2.66927H3.83366M4.50033 1.33594H8.50033C8.86851 1.33594 9.16699 1.63441 9.16699 2.0026V3.33594C9.16699 3.70413 8.86851 4.0026 8.50033 4.0026H4.50033C4.13214 4.0026 3.83366 3.70413 3.83366 3.33594V2.0026C3.83366 1.63441 4.13214 1.33594 4.50033 1.33594Z",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.a4f4373c66cbe1c5a05c10fcb1782d3e.svg";
export { ForwardRef as ReactComponent };